import { emptySplitApi } from '@/api'
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { activeDesignSlice } from './active-design'
import { productsSlice } from './products'
import { selectedPropertiesTabSlice } from './selected-properties-tab'
import { designValidationSlice } from './design-validation'
import { selectedCameraControlSlice } from './camera-control-type'
import { productPickerSlice } from './product-picker'
import { reportPreviewSlice } from './report-preview'

export const store = configureStore({
  reducer: {
    [emptySplitApi.reducerPath]: emptySplitApi.reducer,
    activeDesign: activeDesignSlice.reducer,
    products: productsSlice.reducer,
    selectedPropertiesTab: selectedPropertiesTabSlice.reducer,
    designValidation: designValidationSlice.reducer,
    selectedCameraControlType: selectedCameraControlSlice.reducer,
    productPickerSlice: productPickerSlice.reducer,
    reportPreviewSlice: reportPreviewSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(emptySplitApi.middleware),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
